<template>
  <LoginPage redirectUrl="/files.html"
    bgImgPath="/assets/datahall.jpg"
    :authClient="authClient"
    >
    <template #h1>REDEx</template>
    <template #h3>Access and download cloud hosted files, interrogate BIM and CAD models via a built-in viewer and examine underlying model properties.</template>
    <div><FooterNotice /></div>
  </LoginPage>
</template>
<script setup>
import { isAuthenticated, authenticate, redirect } from "@/js/auth";

const authClient = {
  isAuthenticated: () => {
    return isAuthenticated()
      .then(r => {
        if (r) { // User is authenticated -> proceed
          return ;
        } else { // User is not authenticated. Trigger authentication workflow
          return authenticate();
        }
      })
  },
};

isAuthenticated().then(r => { if (r) { redirect('/files.html', 0); } });

import LoginPage from "@/lib-vue/components/LoginPage.vue";
import FooterNotice from "@/components/FooterNotice.vue";
</script>
